<template lang="pug">
    v-app-bar(app clipped-left color="var(--off-white)" light fixed=true)
        .d-flex.align-center
            router-link(link to="/")
                template(v-if="verifyCurrentUser && currentUser.activated_account_id === 1516")
                    v-img.shrink.mr-2(
                        v-if='windowWidth >= 1000'
                        alt="Volie Logo"
                        class="shrink mr-2"
                        contain
                        src="https://volie-assets.s3.amazonaws.com/system/bdc-central-144x45px.png"
                        transition="scale-transition"
                        width="144"
                    )
                    v-img.shrink.mr-2(
                        v-else
                        alt="Volie Logo"
                        class="shrink mr-2"
                        contain
                        src="https://volie-assets.s3.amazonaws.com/system/bdc-central-hex-45x45px.png"
                        transition="scale-transition"
                        width="45"
                    )

                template(v-else)
                    v-img.shrink.mr-2(
                        v-if='windowWidth >= 1000'
                        alt="Volie Logo"
                        class="shrink mr-2"
                        contain
                        :src="mainLogoUrl"
                        transition="scale-transition"
                        width="144"
                    )
                    v-img.shrink.mr-2(
                        v-else
                        alt="Volie Logo"
                        class="shrink mr-2"
                        contain
                        :src="mainIconUrl"
                        transition="scale-transition"
                        width="45"
                    )

        v-spacer
        template(v-if="inCommunicationCenter && validCurrentAgentStatusRuleAlertText")
            v-icon(large).volie-color-blue.mr-2 mdi-information-outline
            span.text-h5.volie-color-blue {{ currentAgentStatusRule.alert_text }}

        v-spacer

        template(v-if="verifyCurrentUser")
            UserGoals(
                v-if="renderUserGoals && windowWidth >= 800"
            )
            CurrentAgent
            span.mr-5

            template(v-if='windowWidth >= 650')
                IntegrationStatusBeacon.mr-3(
                    v-if="currentUser.need_vin_solutions_auth"
                )

                span.mr-5
                AppointmentDayLog(
                    :appointments-today="appointmentsToday"
                )
                span.mr-5
                ConferenceDayLog(
                    :origin-calls-today="inboundCallsToday"
                    origin-direction="inbound"
                )
                span.mr-5

                ConferenceDayLog(
                    :origin-calls-today="outboundCallsToday"
                    origin-direction="outbound"
                )
                span.mr-5

            template(v-if='windowWidth >= 750')
                CurrentUserClock(
                    :show-timezone-abbreviation="windowWidth >= 1680"
                )
                span.mr-5

            InAppChat(
                v-if="isAgentChatEnabled"
            )

            v-menu(offset-y min-width='200')
                template(v-slot:activator='{ on }')
                    v-btn.volie-color-blue(dark v-on='on' ripple rounded outlined style="border-color: var(--volie-blue);")
                        template(v-if='windowWidth >= 1440')
                            | {{ currentUser.full_name }}
                        template(v-else)
                            v-icon mdi-account
                        v-icon mdi-menu-down
                v-card
                    v-list
                        v-subheader(v-if='windowWidth < 1440')
                            | {{ currentUser.full_name }}
                        v-list-item(ripple :to="`/users/${currentUser.user_key}/edit`")
                            v-list-item-action
                                v-icon mdi-account
                            v-list-item-content
                                v-list-item-title Profile

                        v-list-item(ripple link href='/account_switcher' v-if="currentUserIsSuperAdmin || userHasMultipleAccounts")
                            v-list-item-action
                                v-icon mdi-account-switch
                            v-list-item-content
                                v-list-item-title Switch Accounts
                        
                        v-list-item(ripple link to="/super_admin/accounts" v-if="currentUserIsSuperAdmin && !isOnSuperAdminPage")
                            v-list-item-action
                                v-icon mdi-shield-crown
                            v-list-item-content
                                v-list-item-title Super Admin
                        
                        v-list-item(ripple link to="/" v-if="currentUserIsSuperAdmin && isOnSuperAdminPage")
                            v-list-item-action
                                v-icon mdi-home
                            v-list-item-content
                                v-list-item-title Main App

                        v-list-item(ripple link href='/auth/sso_logout')
                            v-list-item-action
                                v-icon mdi-logout
                            v-list-item-content
                                v-list-item-title Logout

</template>

<script lang="ts">
    import Vue from 'vue';
    import VolieState from '@/store';
    import AppointmentDayLog from '@/components/appointments/dialog_day_log.vue';
    import ConferenceDayLog from '@/components/conferences/dialog_day_log.vue';
    import CurrentAgent from './current_agent.vue';
    import CurrentUserClock from './current_user_clock.vue';
    import IntegrationStatusBeacon from '@/components/integration_app/status_beacon.vue';
    import InAppChat from './in_app_chat.vue';

   // Components
   import UserGoals from "@/components/goals/user_goals/index.vue";

	export default Vue.extend({
        data() {
            return {
                items: [
                    {
                        icon: 'mdi-account',
                        title: 'Profile',
                        to: "",
                    },
                    {
                        icon: 'mdi-logout',
                        title: 'Logout',
                    },
                ],
                windowWidth: 0,
            }
        },
        computed: {
            appointmentsToday() {
                return this.currentUser?.account_user?.appointments_created_today || 0;
            },
            currentUser() {
                return VolieState.currentUser();
            },
            currentUserIsSuperAdmin() {
                return this.currentUser?.activated_role_id === 1;
            },
            isOnSuperAdminPage() {
                return this.$route?.path?.startsWith('/super_admin');
            },
            currentTime() {
                return VolieState.currentTime();
            },
            currentAgentStatusRule() {
                return VolieState.currentAgentStatusRule();
            },
            currentAgentStatusRuleAlertText() {
                return this.currentAgentStatusRule?.alert_text || '';
            },
            inCommunicationCenter() {
                return this.$route?.path === '/communication_center';
            },
            inboundCallsToday() {
                return this.currentUser?.account_user?.inbound_calls_today || 0;
            },
            isAgentChatEnabled() {
                return this.currentUser?.account?.is_agent_chat_enabled || false;
            },
            outboundCallsToday() {
                return this.currentUser?.account_user?.outbound_calls_today || 0;
            },
            renderUserGoals() {
                return !this.$route.fullPath.includes('dashboards/live-dashboard');
            },
            railsVolieBaseUrl() {
                return VolieState.baseRailsUrl();
            },
            verifyCurrentUser() {
                const currentUser = this.currentUser;
                return (!!currentUser && currentUser.user_id > 0 && currentUser.activated_account_id > 0 && currentUser.activated_role_id > 0);
            },
            whiteLabel() {
                return VolieState.whiteLabel();
            },
            mainIconUrl() {
                if (this.whiteLabel?.main_icon_url?.length > 0) {
                    return this.whiteLabel.main_icon_url;
                }

                return "https://volie-assets.s3.us-east-1.amazonaws.com/system/volie_logos_2/favicon_45.png";
            },
            mainLogoUrl() {
                if (this.whiteLabel?.main_logo_url?.length > 0) {
                    return this.whiteLabel.main_logo_url;
                }

                return "https://volie-assets.s3.us-east-1.amazonaws.com/system/volie_logos_2/Volie_144x45px.png";
            },
            userHasMultipleAccounts() {
                return this.currentUser?.accessible_account_ids?.length > 1;
            },
            validCurrentAgentStatusRuleAlertText() {
                return this.currentAgentStatusRuleAlertText.length > 0;
            },
        },
        methods: {
            handleWindowResize() {
                if (window?.innerWidth > 0) {
                    this.windowWidth = window.innerWidth;
                    return;
                }

                this.windowWidth = 0;
            },
        },
        components: {
            AppointmentDayLog,
            ConferenceDayLog,
            CurrentAgent,
            CurrentUserClock,
            UserGoals,
            IntegrationStatusBeacon,
            InAppChat,
        },
        created() {
            this.handleWindowResize();
            window.addEventListener('resize', this.handleWindowResize);
        },
        destroyed() {
            window.removeEventListener('resize', this.handleWindowResize);
        },
	});
</script>

<style lang="scss" scoped>
#app {
    header {
        z-index: 100;
    }
}
</style>
